import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentCheckout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const plan = searchParams.get('plan');

  // Plan details
  const planDetails = {
    vip: {
      name: 'VIP Plan',
      formId: '141',
      formUrl: 'https://sndzone.com/order/form/141',
      price: 5.00,
      currency: 'USD',
      features: [
        '1K Generations/month - Generate up to 1,000 indicators per month',
        'Advanced AI Powered - Access to advanced AI for better code quality',
        'Generation History - Access all your previously generated code',
        '10+ Code Templates - Ready-to-use indicators',
        'Advanced Alert System Version 2 - Next-generation notification system',
        'Code Comments & Documentation - AI-explained code with detailed comments'
      ]
    },
    premium: {
      name: 'Premium Plan',
      formId: '142',
      formUrl: 'https://sndzone.com/order/form/142',
      price: 15.00,
      currency: 'USD',
      features: [
        'Unlimited Generations - Generate as many indicators as you need - no limits!',
        'Advanced AI Powered - Access to advanced AI for better code quality',
        'Built-in SL & TP - Stop Loss & Take Profit automatically integrated',
        'Generation History - Access all your previously generated code',
        '50+ Code Templates - Premium collection of ready-to-use indicators',
        'Advanced Alert System Version 3 - Latest alert technology with advanced features',
        'Template Alert to Telegram - Send trading alerts directly to your Telegram',
        'Code Comments & Documentation - AI-explained code with detailed comments'
      ]
    }
  };

  const selectedPlan = planDetails[plan];

  // If invalid plan, redirect
  if (!selectedPlan) {
    navigate('/');
    return null;
  }

  return (
    <div className="payment-checkout-page min-h-screen bg-gray-50 dark:bg-black py-8">
      <div className="max-w-3xl mx-auto px-4">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="mb-4 text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300"
        >
          ← Back
        </button>

        {/* Page header */}
        <div className="bg-[#ffffff] dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg shadow p-6 mb-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Complete Your Upgrade</h1>
          <p className="text-gray-600 dark:text-gray-400">You're one step away from unlocking premium features!</p>
        </div>

        {/* Plan summary */}
        <div className="bg-[#ffffff] dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {selectedPlan.name}
          </h2>

          {/* Pricing */}
          <div className="mb-6">
            <div className="flex items-baseline gap-2 mb-1">
              <span className="text-3xl font-bold text-teal-600 dark:text-teal-400">
                ${selectedPlan.price.toFixed(2)}
              </span>
              <span className="text-gray-600 dark:text-gray-400">/month</span>
            </div>
            <div className="text-gray-500 dark:text-gray-500">
              Amount to pay: <span className="font-semibold text-gray-900 dark:text-white">${selectedPlan.price.toFixed(2)} {selectedPlan.currency}</span>
            </div>
          </div>

          {/* Features */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">What's included:</h3>
            <div className="space-y-2">
              {selectedPlan.features.map((feature, index) => (
                <div key={index} className="flex items-start gap-2">
                  <span className="text-green-500 mt-0.5">✓</span>
                  <span className="text-gray-700 dark:text-gray-300">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Payment form */}
        <div className="bg-[#ffffff] dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Payment Details</h3>

          {/* Direct iframe to OnPay form */}
          <iframe
            src={selectedPlan.formUrl}
            style={{
              width: '100%',
              minHeight: '800px',
              height: '800px',
              border: 'none',
              display: 'block',
              overflow: 'hidden'
            }}
            title="OnPay Payment Form"
            frameBorder="0"
            scrolling="yes"
            onLoad={(e) => {
              console.log('✅ OnPay iframe loaded successfully');
              // Auto-resize iframe based on content
              try {
                const iframe = e.target;
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
              } catch (err) {
                console.log('Cannot access iframe content (CORS)');
              }
            }}
            onError={() => {
              console.error('❌ OnPay iframe failed to load');
            }}
          />

          {/* Fallback link */}
          <div className="mt-4 text-center text-sm text-gray-500">
            <p>
              Having trouble?
              <a
                href={selectedPlan.formUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-600 hover:underline ml-1"
              >
                Open payment form in new window
              </a>
            </p>
          </div>

          {/* Security badge */}
          <div className="mt-6 pt-6 border-t text-center text-sm text-gray-500">
            🔒 Secure payment powered by <strong>OnPay.my</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCheckout;
